<template>
  <div>
    <Modal max-width="340" :show.sync="showBookingCreation" :close="closeOrderModal">
      <template #title>
        <span class="title">Ajouter un dossier visible </span>
      </template>
      <template #text>
        <v-text-field
          v-model="booking"
          hide-details
          dense
          outlined
          label="Numero de Dossier"
          type="text"
          class="mb-2"
        />
      </template>
      <template #actions>
        <v-row>
          <v-spacer />
          <v-btn width="292" class="mr-2" :disabled="!disabledButton" color="secondary" @click="generateCode()">
            <v-icon>mdi-plus</v-icon>
            <span class="ml-2 d-none d-sm-inline-block">Ajouter Dossier</span>
          </v-btn>
        </v-row>
      </template>
    </Modal>
  </div>
</template>
<script>
import { EventBus } from '../../mixins';
import { requests, utils } from '@/mixins/index';
import Modal from '@/components/Modal/Modal';

export default {
  components: { Modal },
  mixins: [requests, utils],
  props: { customer: Object },
  data () {
    return {
      booking: '',
      showBookingCreation: false
    };
  },
  computed: {
    disabledButton () {
      return true;
    }
  },
  mounted () {
    EventBus.$on('startAddBooking', () => {
      this.booking = '';
      this.showBookingCreation = true;
    });
  },
  methods: {
    closeOrderModal () {
      this.showBookingCreation = false;
    },
    async generateCode () {
      this.closeOrderModal();
      let notification = {
        message: "Ajout d'un dossier aux dossiers visibles par le client",
        type: 'info',
        timeout: 16000
      };

      EventBus.$emit('show-notifications', [notification]);
      const response = await this.addVisibleOrder(this.booking, this.customer.uuid);
      if (!response.success) {
        notification = {
          message: response.message,
          type: 'danger'
        };

        EventBus.$emit('show-notifications', [notification]);
        return;
      }
      notification = {
        message: response.message,
        type: 'success'
      };
      EventBus.$emit('show-notifications', [notification]);
      EventBus.$emit('user-updated');
    }
  }
};
</script>
